import { Navigate } from 'react-router';

import { ROUTES } from '@/app/routes/enums'; // Barrel export from index.ts
import { useAuth } from '@/auth/hooks/useAuth';

/**
 * Root path redirect component
 * - If authenticated: redirect to policy list
 * - If not authenticated: redirect to login
 */
export function RootRedirect() {
  const { isAuthenticated } = useAuth();

  return (
    <Navigate
      to={isAuthenticated ? ROUTES.POLICY_LIST : ROUTES.LOGIN}
      replace
    />
  );
}
